var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{style:({ background: !_vm.isBg ? 'linear-gradient(165deg, #e8efe9 0%, #f7f4ef 48%, #eef3ef 100%)' : 'none' }),attrs:{"id":"app"}},[_c('div',{staticClass:"back-style",style:({
        background: !_vm.isBg
          ? 'radial-gradient(90% 60% at 8% 0%, rgba(26, 107, 92, 0.14), transparent 55%), radial-gradient(70% 50% at 100% 100%, rgba(196, 92, 38, 0.08), transparent 50%)'
          : 'none'
      })}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }